import logger from '@/domains/core/observability/logger';
import { getAppSetting } from '@/domains/core/settings/appSettings';

export function getConversationIds(): Record<string, number> {
  try {
    const ids = JSON.parse(
      getAppSetting('EXTERNAL_ZENDESK_CONVERSATION_IDS') ?? '{}',
    );
    return ids;
  } catch (error) {
    logger.error(error);
    return {};
  }
}
